import React, { PropsWithChildren } from 'react';

import { SectionContainerContainer } from './sectionContainer.styled';

export default function SectionContainer({
  children,
  title: Title,
  subTitle: SubTitle,
  id,
}: PropsWithChildren<{ title: React.ElementType; subTitle?: React.ElementType; id?: string }>) {
  return (
    <SectionContainerContainer id={id}>
      {Boolean(Title) && <Title />}
      {Boolean(SubTitle) && <SubTitle />}
      {children}
    </SectionContainerContainer>
  );
}
